export const webURL = process.env.REACT_APP_PAW_LOCAL
  ? 'http://localhost:3000'
  : 'https://www.petadoptionwebsite.com';

export const S3_BASE = process.env.REACT_APP_PAW_LOCAL
  ? 'https://paw-img-local.s3.amazonaws.com/'
  : 'https://paw-img.s3.amazonaws.com/';
